const CompletedCheckIcon = ({ size = 20, className = "" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 1C14.9667 1 19 5.03329 19 10C19 14.9667 14.9667 19 10 19C5.03329 19 1 14.9667 1 10C1 5.03329 5.03329 1 10 1Z" stroke="#4AB932" strokeWidth="2"/>
  <path d="M5.42578 10.449L8.31612 13.2832L14.1529 7.25" stroke="#4AB932" strokeWidth="1.68369" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
);

export default CompletedCheckIcon;
